import React, { useState, useContext } from 'react';
import Drawer from '@material-ui/core/Drawer';
import Pagination from 'modules/common/components/Pagination';
import GenericList from 'modules/common/components/GenericList';
import PropTypes from 'prop-types';
import Select from 'react-select';
import _ from 'lodash';
import cn from 'classnames';
import { reactSelectCustomStyle } from 'modules/common/components/Select';

import CmsContext from '../../../context/CmsContext';

const years = _.range(2000, new Date().getFullYear() + 1).sort((a, b) => b - a);

const yearOption = years.map((year) => ({
  label: year,
  value: year,
}));

const statusOption = [
  { label: 'ALL STATUS', value: '' },
  { label: 'PENDING', value: 'PENDING' },
  { label: 'FOR APPEARANCE', value: 'FOR APPEARANCE' },
  { label: 'FOR PRINTING', value: 'FOR PRINTING' },
  { label: 'PRINTED', value: 'PRINTED' },
  { label: 'WAITING FOR PAYMENT', value: 'WAITING FOR PAYMENT' },
  { label: 'PROCESSING', value: 'PROCESSING' },
  { label: 'REJECTED', value: 'REJECTED' },
  { label: 'FOR PICK-UP', value: 'FOR PICK-UP' },
  { label: 'FOR CHECKING', value: 'FOR CHECKING' },
  { label: 'RECEIVED', value: 'RECEIVED' },
  { label: 'PAID', value: 'PAID' },
  { label: 'PENDING LAB TEST', value: 'PENDING LAB TEST' },
  { label: 'EXPIRED REFERENCE NUMBER', value: 'EXPIRED REFERENCE NUMBER' },
];

function GenericListPair({
  moduleName,
  getData,
  setKeyword,
  keyword,
  keywordPlaceholder,
  listName,
  label,
  renderItem,
  isLoading,
  selected,
  data,
  dataPager,
  handleSelectRow,
  renderTopContent, // render a 'More' customizable component on top of "content"
  renderContent,
  setParams,
  statusFilter,
  setStatusFilter,
  setYearFilter,
  sideBarFilter,
  resetStatusFilter,
  status,
  noSearch,
  searchButton,
  searchButtonLabel,
  addButton,
  addButtonLabel,
  customFilter,
  selectedKey,
  downloadCSV,
  statusOptions,
  notificationListConfig,
  certificateFilter,
  searchToggle,
  is_generated,
  handleSelectFilter,
  filterOption,
  customButton,
  noRightCard,
}) {
  const [pageFilterData, setFilterPageData] = useState({
    is_paginated: 1,
    isPaginate: 1,
  });
  const [showSide, setShowSide] = useState(false);
  const handleChangePage = (page) => {
    setFilterPageData({ ...pageFilterData, page });
    let args = {};

    if (setParams.is_valid === 'ALL') {
      args = _.omit(args, ['is_valid']);
    } else {
      args = setParams;
    }

    getData({ ...pageFilterData, page, ...args });
  };

  const handleSidebarToggle = () => (e) => {
    e.preventDefault();
    setShowSide(!showSide);
  };

  const handleClose = () => {
    setShowSide(false);
  };

  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');

  return (
    <div className="container-fluid">
      <div className="row">
        {/* LEFT SECTION */}
        <div className="col-4 p-0">
          <div className="card-main  card left-section sticky p-0 section-listing">
            <div className="container-fluid card-section-content px-0">
              <div className="list-name">{moduleName}</div>
              {downloadCSV && (
                <div className="download-csv d-flex align-items-center px-3">
                  <a
                    href={downloadCSV()}
                    className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary  w-100"
                    style={{ color: 'white' }}
                  >
                    {`Download ${
                      _.get(CMS_COMPONENTS, 'SMART_CITY_SIDE_MENU_LABELS_V2')
                        ? 'Registrants/ Subscribers'
                        : 'Subscribers List'
                    }`}
                  </a>
                </div>
              )}
              <div className="search-filter">
                {noSearch === true ? (
                  ''
                ) : (
                  <div className="form-wrapper d-flex align-items-center search-container">
                    <i className="fas fa-search icon-search mr-2" />
                    <input
                      className="search-input w-100"
                      type="text"
                      name="keyword"
                      id="keyword"
                      placeholder={keywordPlaceholder}
                      onChange={setKeyword}
                      value={keyword || ''}
                      required
                    />
                    {sideBarFilter ? (
                      <div className="input-group-append">
                        <button
                          // style={{ width: '150px' }}
                          // disabled={approving}
                          onClick={handleSidebarToggle()}
                          className="btn btn-primary font-weight-bold mr-2 btn-dark"
                          type="button"
                        >
                          <i className="fas fa-filter text-white" />
                        </button>
                      </div>
                    ) : (
                      ''
                    )}
                    {sideBarFilter && showSide ? (
                      <Drawer
                        // PaperProps={{ classes: { root: classes.dialogPaper } }}
                        anchor="right"
                        open={showSide}
                        onClose={handleClose}
                      >
                        <div className="mt-5 px-3" style={{ width: '24rem' }}>
                          <div className="d-flex mb-3">
                            <h2> Filter </h2>
                            <button
                              onClick={handleClose}
                              type="button"
                              className="btn btn-link ml-auto"
                            >
                              <i className="fas fa-times" />
                            </button>
                          </div>
                          <div className="form-input-group mb-2">
                            <label className="label-reports font-weight-bold">
                              Year
                            </label>
                            <Select
                              value={yearOption.find(
                                (item) => status === _.get(item, 'value')
                              )}
                              onChange={setYearFilter}
                              options={yearOption}
                            />
                          </div>
                          <div className="form-input-group mb-2">
                            <label className="label-reports font-weight-bold">
                              Status
                            </label>
                            <Select
                              value={(statusOptions || statusOption).find(
                                (item) => status === _.get(item, 'value')
                              )}
                              onChange={setStatusFilter}
                              options={statusOptions || statusOption}
                            />
                          </div>
                          <div className="buttons-modal">
                            <button
                              onClick={resetStatusFilter}
                              type="button"
                              className="btn btn-primary font-weight-bold mr-2 btn-dark"
                              style={{ width: 150 }}
                            >
                              Clear Filter
                            </button>
                            <button
                              className="btn btn-primary cms-bg-color-primary font-weight-bold"
                              type="submit"
                              style={{ width: 150 }}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </Drawer>
                    ) : (
                      ''
                    )}
                  </div>
                )}
                {statusFilter === true ? (
                  <>
                    <div
                      className={cn(
                        'd-flex align-items-right',
                        !_.isEmpty(searchToggle) ? 'mt-3' : 'my-3'
                      )}
                    >
                      {certificateFilter ? (
                        <div className="d-flex align-items-center">
                          <div>
                            <label className="form-label mt-2 mb-0">
                              <span className="text-muted">
                                <h6>Type</h6>
                              </span>
                            </label>
                          </div>
                          <Select
                            styles={reactSelectCustomStyle}
                            value={
                              filterOption.find(
                                (item) => is_generated === _.get(item, 'value')
                              ) || ''
                            }
                            onChange={handleSelectFilter}
                            options={filterOption}
                          />
                        </div>
                      ) : (
                        ''
                      )}
                      <div className="d-flex align-items-center ml-auto">
                        <div>
                          <label className="form-label mt-2 mb-0">
                            <span className="text-muted">
                              <h6>Filter By Status:</h6>
                            </span>
                          </label>
                        </div>
                        <Select
                          styles={reactSelectCustomStyle}
                          value={(statusOptions || statusOption).find(
                            (item) => status === _.get(item, 'value')
                          )}
                          onChange={setStatusFilter}
                          options={statusOptions || statusOption}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  ''
                )}
                {!_.isEmpty(searchToggle) ? (
                  <div className="d-flex align-items-right">
                    <div className="d-flex align-items-center ml-auto">
                      <input
                        type="checkbox"
                        id="toggle"
                        className="ml-auto"
                        value={searchToggle.value}
                        checked={searchToggle.value}
                        onChange={() =>
                          searchToggle.toggle(!searchToggle.value)
                        }
                      />
                      <label className="form-label mt-2 mb-0" htmlFor="toggle">
                        <span className="text-muted">
                          <h6>&nbsp;Search by {searchToggle.label}</h6>
                        </span>
                      </label>
                    </div>
                    {/* <Select
                            styles={reactSelectCustomStyle}
                            value={
                              filterOption.find(
                                item => is_generated === _.get(item, 'value')
                              ) || ''
                            }
                            onChange={handleSelectFilter}
                            options={filterOption}
                          /> */}
                  </div>
                ) : (
                  ''
                )}
                {customFilter}
                {customButton}
              </div>
              <div className="transaction-list flex-grow-1">
                <GenericList
                  height={100}
                  listName={listName}
                  label={label}
                  labelKey={renderItem}
                  isLoading={isLoading}
                  selected={selected.toString()}
                  data={data}
                  pagerData={dataPager}
                  rowsCount={dataPager.count || 0}
                  onSelectRow={handleSelectRow}
                  selectedKey={selectedKey}
                  notificationListConfig={notificationListConfig}
                />
              </div>
              <div className="list-pagination">
                <div className="d-flex justify-content-center text-center align-item-center">
                  <Pagination data={dataPager} onChange={handleChangePage} />
                </div>
              </div>

              {addButton && (
                <button
                  type="button"
                  onClick={addButton}
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold mx-auto mb-3"
                >
                  {addButtonLabel} <i className="fas fa-plus" />
                </button>
              )}

              {searchButton && (
                <button
                  type="button"
                  onClick={searchButton}
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold mx-auto mb-3"
                >
                  {searchButtonLabel} <i className="fas fa-search" />
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="col-8 p-0">
          {/* RIGHT SECTION */}
          {renderTopContent()}
          <div
            className={`${!noRightCard && 'card-main card'} right-section ${
              !renderTopContent() && 'h-100'
            }`}
          >
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
}

GenericListPair.defaultProps = {
  moduleName: 'Transaction List',
  getData: () => {}, // GET LIST
  setKeyword: () => {}, // ONCHANGE OF SEARCH
  keyword: '', // SEARCH VALUE
  downloadCSV: null,
  status: '',
  setStatusFilter: () => {}, // onchange of status filter
  setYearFilter: () => {}, // onchange of status filter
  keywordPlaceholder: '',
  setParams: {},
  statusFilter: false,
  noSearch: false,
  listName: '',
  label: '',
  renderItem: '',
  isLoading: false,
  selected: '', // match.params.business_Id
  data: [], // LIST
  dataPager: {
    total: 0,
    total_pages: 0,
  },
  handleSelectRow: () => {},
  renderContent: () => {}, // CONTENT COMPONENT
  renderTopContent: () => {}, // TOP CONENT COMPONENT
  sideBarFilter: false,
  resetStatusFilter: () => {},
  addButton: null,
  addButtonLabel: 'Add',
  searchButton: null,
  searchButtonLabel: 'Search',
  customFilter: undefined,
  selectedKey: 'id',
  statusOptions: null,
  notificationListConfig: () => {},
  certificateFilter: false,
  searchToggle: {},
  is_generated: '',
  handleSelectFilter: () => {},
  filterOption: null,
  customButton: undefined,
  noRightCard: false,
};

GenericListPair.propTypes = {
  getData: PropTypes.instanceOf(Function),
  setKeyword: PropTypes.instanceOf(Function),
  setStatusFilter: PropTypes.instanceOf(Function),
  setYearFilter: PropTypes.instanceOf(Function),
  sideBarFilter: PropTypes.bool,
  resetStatusFilter: PropTypes.instanceOf(Function),
  keyword: PropTypes.string,
  downloadCSV: PropTypes.instanceOf(Function),
  moduleName: PropTypes.string,
  status: PropTypes.string,
  keywordPlaceholder: PropTypes.string,
  setParams: PropTypes.instanceOf(Object),
  listName: PropTypes.string,
  label: PropTypes.string,
  renderItem: PropTypes.instanceOf(Function),
  isLoading: PropTypes.bool,
  statusFilter: PropTypes.bool,
  selected: PropTypes.string,
  noSearch: PropTypes.bool,
  data: PropTypes.instanceOf(Array),
  dataPager: PropTypes.instanceOf(Object),
  handleSelectRow: PropTypes.instanceOf(Function),
  renderContent: PropTypes.instanceOf(Function),
  renderTopContent: PropTypes.instanceOf(Function),
  addButton: PropTypes.func,
  addButtonLabel: PropTypes.string,
  searchButton: PropTypes.func,
  searchButtonLabel: PropTypes.string,
  customFilter: PropTypes.node,
  selectedKey: PropTypes.string,
  statusOptions: PropTypes.instanceOf(Array),
  notificationListConfig: PropTypes.instanceOf(Function),
  certificateFilter: PropTypes.bool,
  searchToggle: PropTypes.instanceOf(Object),
  is_generated: PropTypes.string,
  handleSelectFilter: PropTypes.instanceOf(Function),
  filterOption: PropTypes.instanceOf(Array),
  customButton: PropTypes.instanceOf(Object),
  noRightCard: PropTypes.bool,
};

export default GenericListPair;
